import { merge, mergeDeep } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from '../../entities/groups/entity';

const coreReducer = entity.getReducer();

const initialState = {
  groupIds: [],
  error: null,
  isLoading: false,
  pagination: {
    pageSize: 10,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
  filterOptions: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TYPES.LOAD_REQUEST:
      if (action.payload.page === 1) {
        return { ...initialState, filterOptions: state?.filterOptions, isLoading: true };
      }
      return merge(state, { error: null, isLoading: true });
    case TYPES.LOAD_REQUEST_SUCCESS:
      return mergeDeep(state, {
        ...action.payload,
        error: null,
        isLoading: false,
      });
    case TYPES.LOAD_REQUEST_ERROR:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    case TYPES.CLEAR_STATE:
      return { ...initialState, filterOptions: state?.filterOptions };
    case TYPES.UPDATE_FILTER_OPTIONS:
      return merge(state, {
        filterOptions: action.payload,
      });
    default:
      return coreReducer(state, action);
  }
}
